import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter} from "@angular/core";
import {Observable} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';

declare var $:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-validate',
    templateUrl: 'validate.component.html',
    styleUrls: ['validate.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.SubscriptionService, Communication.AccesscodeService],
    standalone: false
})
export class ValidateComponent implements OnInit, OnDestroy {

  isUserChecked:boolean=false;
  accessCode:string="";
  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];


  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private usersApi:Communication.UsersService,
              private subscriptionsApi:Communication.SubscriptionService,
              private accescodeApi:Communication.AccesscodeService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              private notificationService: NotificationService,
              public translate: TranslateService
  )
  {





  }

  ngOnInit() {

    this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
      (event: NavigationEvent) => this.onNavigationEvent(event)
    ));

    this.subscriptions.push(this.activatedRoute.params.subscribe(
      (param) => {
        //convert string to number with +
        this.accessCode = param['code'];
        console.log("accessCode:" + this.accessCode);

      })
    );

    let viewURL:string = "";
    if(this.accessCode != "")
      viewURL = Config.WEB_APP_URL + "/view/" + this.accessCode;

    this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.VALIDATE, "", null, "", "", "", "", viewURL, ""));
  }

  verifyDocument(){
    console.log("accessCode " + this.accessCode);
    this.router.navigate(['/view', this.accessCode]);
  }


  private onNavigationEvent(event:NavigationEvent) {
   /* switch (event.acton) {
      case "ROTATE":
        this.rotate(Number(event.value));
        break;
      }
    }*/
  }



  ngOnDestroy() {

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }
}
